import RadioGroupField from 'components/forms/radioGroupField/RadioGroupField';
import PropertyFormFieldLabel from 'pages/property/common/PropertyFormFieldLabel';
import { useTranslation } from 'react-i18next';

const CheckInTimeStartField = () => {
  const { t } = useTranslation();

  const checkInTimeStartOptions = [false, true].map((value) => ({
    label: t(
      `pageProperty.mainSettings.airbnbSettings.checkInTimeStartOptions.${value}`,
    ),
    value: `${value}`,
    // only show tooltip for Default option
    ...(value === false && {
      tooltipText: t(
        'pageProperty.mainSettings.airbnbSettings.checkInTimeStartDefaultTooltip',
      ),
    }),
  }));

  return (
    <RadioGroupField
      label={
        <PropertyFormFieldLabel name="airbnbSettings.checkInTimeStartFlexible">
          {t('pageProperty.mainSettings.airbnbSettings.checkInTimeStart')}
        </PropertyFormFieldLabel>
      }
      name="airbnbSettings.checkInTimeStartFlexible"
      options={checkInTimeStartOptions}
      colSmInput={7}
      colSmLabel={5}
      horizontal
    />
  );
};

export default CheckInTimeStartField;
